<template>
  <div>
    <lk-modal
    :value="show"
    width="900"
    :title="tableData.length > 0 ? '选择商品' : '选择销售订单'"
    @on-cancel="onCancel"
    @on-visible-change="onVisibleChange"
    >
      <div style="padding: 3px 16px 2px 16px">
        <div class="return-search-query-container">
          <div class="query-item">
            <label style="margin-right:8px">销售订单号:</label>
            <lk-input v-model="queryParams.orderNo" style="width: 256px" placeholder="请输入"/>
          </div>
          <div class="query-item">
            <lk-button type='primary' class="search-btn" @click="onSearch">查询</lk-button>
            <lk-button class="reset-btn" @click="reset">重置</lk-button>
          </div>
        </div>
        <div v-if="tableData.length > 0">
          <lk-table
            border
            :columns='columns'
            :data='tableData'
            @on-selection-change="onSelectionChanged"
            no-data-text="未找到商品，请先进行商品首营申请"
            ></lk-table>
          <div style="text-align:right;margin-top:14px">
            <lk-page :total="count" size="small" show-sizer show-elevator @on-change='onPageChange' @on-page-size-change='onSizeChange'></lk-page>
          </div>
        </div>
      </div>
      <div slot="footer">
        <!-- <span class="modal-footer-chosen">已选：{{pureTempRes.length}} 项</span> -->
        <lk-button @click="onCancel" style="margin-left:24px">取消</lk-button>
        <lk-button type="primary"  @click="onOK" style="margin-left:16px">确定</lk-button>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import utils from '../../libs/utils';
import afterSale from '../../services/afterSale';

export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selectedTable: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      queryParams: {
        orderNo: '',
      },
      page: 1,
      size: 10,
      tempRes: [],
      isMarketingPromote: false, // 是否是营销活动
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
        },
        {
          title: '销售单号',
          minWidth: 116,
          key: 'orderNo',
        },
        {
          title: '商品名称',
          minWidth: 116,
          key: 'goodsName',
        },
        {
          title: '通用名称',
          minWidth: 116,
          key: 'approvedDrugNames',
        },
        {
          title: '规格',
          minWidth: 116,
          key: 'specifications',
        },
        {
          title: '剂型',
          minWidth: 116,
          key: 'dosageForm',
        },
        {
          title: '单位',
          minWidth: 116,
          key: 'goodsUnit',
        },
        {
          title: '批次',
          minWidth: 116,
          key: 'goodsBatch',
        },
        {
          title: '销售日期',
          minWidth: 116,
          key: 'createTimeStr',
        },
        {
          title: '单价',
          minWidth: 116,
          key: 'realPrice',
        },
        {
          title: '销售数量',
          minWidth: 116,
          key: 'goodsCount',
        },
        {
          title: '金额',
          minWidth: 116,
          key: 'amount',
        },
      ],
      tableData: [],
      count: 0,
    };
  },
  computed: {
    pureTempRes() {
      return this.tempRes.filter(item => !this.selectedTable.includes(item.id));
    },
  },
  methods: {
    onVisibleChange(status) {
      if (status) {
        this.queryGoodsStore();
      }
    },
    onSelectionChanged(selection) {
      if (selection.length <= 0) {
        this.tempRes = [];
        return;
      }
      this.tempRes = selection;
    },
    onSearch() {
      this.page = 1;
      this.queryGoodsStore();
    },
    queryGoodsStore() {
      const params = Object.assign({}, this.queryParams);
      params.page = this.page;
      params.size = this.size;
      if (params.orderNo) {
        afterSale.listRefundOrderDetail(params).then((responseData) => {
          if (responseData.data.status === 200) {
            let res = responseData.data.data;
            if (res.list.length === 0) {
              this.$Message.warning('暂无退货单');
            }
            this.tableData = [];
            this.isMarketingPromote = res.list.length > 0 ? res.list[0].isPromote : false;
            res.list.length && res.list.forEach((item) => {
              const targetItem = Object.assign({}, item.saleOrderDetail);
              targetItem.refundableWarehouseLocationList = item.refundableWarehouseLocationList;
              targetItem.isMarketingPromote = item.isPromote ? 1 : 0;
              this.selectedTable.forEach((TableItem) => {
                if (TableItem === item.saleOrderDetail.id) {
                  targetItem._checked = true;
                  targetItem._disabled = true;
                }
              });
              if (item.isPromote && item.saleOrderDetail.refundable) {
                targetItem._checked = true;
                targetItem._disabled = true;
              }
              if (!item.saleOrderDetail.refundable) {
                targetItem._disabled = true;
              }
              targetItem.createTimeStr = utils.formatTime(item.saleOrderDetail.createTime, 'YYYY/MM/DD');
              this.tableData.push(targetItem);
            });
            if (this.isMarketingPromote) {
              this.tempRes = this.tableData;
            }
            this.count = res.count;
          } else {
            this.$Message.error(responseData.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      }
    },
    onCancel() {
      this.$emit('cancel');
      this.reset();
    },
    reset() {
      this.tempRes = [];
      this.queryParams = {
        orderNo: '',
      };
      this.tableData = [];
    },
    onOK() {
      if (this.tempRes.length > 0) {
        this.$emit('ok', this.tempRes);
        this.reset();
      } else {
        this.$emit('cancel');
        this.reset();
      }
    },
    onSizeChange(size) {
      this.size = size;
      this.queryGoodsStore();
    },
    onPageChange(page) {
      this.page = page;
      this.queryGoodsStore();
    },
  },
};
</script>
<style lang="less" scoped>
.return-search-query-container{
  display: flex;
  padding-bottom: 16px;
  line-height: 35px;
  .query-item{
    margin-right: 16px;
    display: flex;
  }
  .reset-btn{
    margin-left: 8px;
  }
}
</style>
